import ApplicationController from './application'
import { numbers_only } from '../helpers/helpers'

export default class extends ApplicationController {

  static targets = ['input']

  connect() {
    if (!this.hasInputTarget) return

    const input = this.inputTarget

    input.addEventListener('input', (e) => {
      // Remove all non-numeric characters
      let value = numbers_only(input.value)

      // If the value is empty, reset it
      if (!value) {
        input.value = ''
        return
      }

      // Format the value as cents (start from the right)
      value = parseInt(value, 10).toString() // Ensure it's a valid number

      // Add leading zeros if necessary to ensure at least 3 digits
      while (value.length < 3) {
        value = '0' + value
      }

      const rands = value.slice(0, -2)
      const cents = value.slice(-2)

      // Add commas to the rands part
      const formattedRands = rands.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

      // Combine rands and cents
      input.value = `${formattedRands}.${cents}`
    })
  }
}
